/**
 * Appends Supabase image transformation parameters to storage URLs
 * to serve properly sized images and reduce bandwidth.
 */
export function optimizeStorageUrl(url: string | undefined | null, width: number, height?: number): string {
  if (!url) return '';
  
  // Only transform Supabase storage URLs
  if (!url.includes('supabase.co/storage/v1/object/public/')) return url;
  
  // Replace /object/public/ with /render/image/public/ and add transform params
  const transformedUrl = url.replace(
    '/storage/v1/object/public/',
    '/storage/v1/render/image/public/'
  );
  
  const separator = transformedUrl.includes('?') ? '&' : '?';
  const h = height || width;
  return `${transformedUrl}${separator}width=${width}&height=${h}&resize=cover`;
}
